import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { decodeToken } from "../helpers/auth_token_helper"
import { useStore } from "../contexts/StoreContext"
import { canStorePublishBags, PUBLISHING_BLOCKED_MESSAGE } from "../helpers/store_access_helper"
import toastr from "toastr"

const Authmiddleware = (props) => {

  const payload = decodeToken();
  const { store, loading, refreshStore } = useStore()
  const publishingBlocked = props.requiresPublishing && !loading && !canStorePublishBags(store)

  useEffect(() => {
    refreshStore()
  }, [refreshStore])

  useEffect(() => {
    if (publishingBlocked) toastr.warning(PUBLISHING_BLOCKED_MESSAGE)
  }, [publishingBlocked])
  const isTokenExpired = payload ? payload.exp * 1000 < Date.now() : true;

  if (!payload || isTokenExpired) {

    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }

  const userRole = payload.role;
  if (
    props.requiredRoles?.length > 0
    && !props.requiredRoles.includes(userRole)
  ) {
    return <Navigate to="/404" replace />;
  }

  if (publishingBlocked) {
    return <Navigate to="/dashboard" replace />
  }

  if (props.requiresPublishing && loading) return null

  return (<React.Fragment>
    {props.children}
  </React.Fragment>);
};

export default Authmiddleware;
